import style from './AgencyUserBurgerMenu.module.css';
import { useState } from 'react';
import { FaPowerOff } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from '../../../../redux/auth/selectors';

import { logOut } from '../../../../redux/auth/operations';
import { useWebSocket } from '../../../WebSocketProvider/WebSocketProvider';

const AgencyUserBurgerMenu = ({ close }) => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const { sendData } = useWebSocket();

  const handleLogOutClick = () => {
    sendData({ id: user._id }, 'removeOnlineUser');
    dispatch(logOut());
    close();
  };
  return (
    <div className={style.menuContainer}>
      <button className={style.logoutButton} onClick={handleLogOutClick}>
        <FaPowerOff className={style.logoutIcon} />
        Log Out
      </button>
    </div>
  );
};

export default AgencyUserBurgerMenu;
